import { css, useTheme } from '@emotion/react';
import type { SerializedStyles, Theme } from '@emotion/react';

import { breakpoints, typography, typography2 } from '@coursera/cds-core';

type TextCategory = 'title' | 'header' | 'subHeader' | 'body';

export type MobileFontSizeStyle = {
  [K in TextCategory]?: SerializedStyles;
};

export interface DegreeDescriptionPageTheme extends Theme {
  mobileFontSizeStyle: MobileFontSizeStyle;
}

export function isDegreeDescriptionPageTheme(theme: Theme): theme is DegreeDescriptionPageTheme {
  return !!(theme as DegreeDescriptionPageTheme).mobileFontSizeStyle;
}

export const degreeDescriptionPageTheme = (theme: Theme): DegreeDescriptionPageTheme => ({
  ...theme,
  mobileFontSizeStyle: {
    title: css`
      ${breakpoints.down('sm')} {
        ${typography.h1semibold};
      }
    `,
    header: css`
      ${breakpoints.down('sm')} {
        ${typography2.subtitleMedium};
      }
    `,
    subHeader: css`
      ${breakpoints.down('sm')} {
        ${typography2.subtitleMedium};
      }
    `,
    body: css`
      ${breakpoints.down('sm')} {
        ${typography2.bodySecondary};
      }
    `,
  },
});

export const useDegreeDescriptionPageTheme = () => {
  const theme = useTheme();
  if (!isDegreeDescriptionPageTheme(theme)) {
    throw new Error(
      'degreeDescriptionPageTheme can only be used in the context of a DegreeDescriptionPageTheme. Wrap this component with DegreeDescriptionPageThemeProvider.'
    );
  }
  return theme as DegreeDescriptionPageTheme;
};
